import SvgIcon, { SvgIconProps } from "./SvgIcon";

const LifestyleIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2931 12.0321C15.9747 12.4446 16.7534 12.6694 17.5501 12.6839C18.0874 12.6802 18.6178 12.5621 19.1058 12.3374C19.594 12.1128 20.0287 11.7868 20.381 11.3812C21.3339 10.2694 21.8126 8.82827 21.7144 7.36737C21.6574 5.96319 21.3489 4.58065 20.8034 3.28546C20.7409 3.15941 20.6424 3.05468 20.5204 2.98448C20.3985 2.91427 20.2584 2.88171 20.1181 2.8909C18.7242 3.06544 17.373 3.48811 16.1283 4.1389C14.815 4.78563 13.8065 5.92013 13.3184 7.30018C13.0176 8.19424 13.0522 9.16712 13.4154 10.0376C13.7787 10.9081 14.446 11.617 15.2931 12.0321ZM6.21829 15.4772C6.7888 15.7808 7.42394 15.9427 8.07015 15.9495C8.68261 15.9324 9.28337 15.7781 9.82821 15.4978C10.373 15.2174 10.848 14.8184 11.218 14.33C11.8692 13.6471 12.2498 12.7507 12.289 11.8079C12.3282 10.8651 12.0233 9.94016 11.4311 9.20553C10.4957 8.0795 9.1566 7.36447 7.70054 7.21353C6.308 7.0328 4.89435 7.10269 3.52643 7.41993C3.39143 7.46101 3.27145 7.54072 3.1812 7.64922C3.09096 7.75771 3.03441 7.89025 3.0186 8.03049C2.95722 9.4339 3.14675 10.8371 3.57829 12.1739C3.99272 13.5777 4.94037 14.7635 6.21829 15.4772ZM12.9274 20.9301C13.0586 21.0461 13.2277 21.1101 13.4029 21.1104C13.4346 21.1105 13.4663 21.1086 13.4979 21.1046C13.5917 21.0926 13.6821 21.0623 13.7642 21.0154C13.8463 20.9684 13.9184 20.9057 13.9763 20.8309C14.0341 20.7562 14.0766 20.6707 14.1015 20.5795C14.1263 20.4882 14.1328 20.393 14.1209 20.2992C13.2445 13.3958 17.0643 10.0176 17.2275 9.87745C17.3681 9.75235 17.4543 9.57713 17.4673 9.38933C17.4804 9.20152 17.4193 9.01607 17.2973 8.8727C17.1753 8.72935 17.002 8.63948 16.8145 8.62235C16.627 8.60524 16.4403 8.66223 16.2943 8.78113C16.157 8.89511 13.871 10.8848 12.9385 14.8315C11.5497 12.6878 9.28817 11.7697 9.15867 11.7183C9.07042 11.6836 8.97623 11.6666 8.8814 11.6682C8.78658 11.67 8.69297 11.6903 8.60601 11.7281C8.51906 11.766 8.44042 11.8206 8.37457 11.8888C8.30871 11.957 8.25696 12.0375 8.22222 12.1259C8.18749 12.2141 8.17044 12.3083 8.17212 12.4031C8.17381 12.498 8.19416 12.5915 8.23201 12.6784C8.26985 12.7654 8.32444 12.844 8.39267 12.9099C8.46091 12.9757 8.54149 13.0276 8.62975 13.0623C8.66431 13.0758 12.1491 14.486 12.5331 17.846C12.5368 17.8786 12.5428 17.9106 12.5509 17.9421C12.5343 18.7357 12.5754 19.5818 12.6895 20.4806C12.7115 20.6544 12.796 20.8142 12.9274 20.9301Z"
          fill="currentColor"
        />
      ) : (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4317 11.3857C17.402 12.5231 18.9384 11.7895 19.8014 10.8467C20.6888 9.87757 21.0488 8.49397 20.9943 7.20476C20.9116 5.22861 20.2908 3.59009 20.1244 3.2583C19.7537 3.27971 18.0237 3.56187 16.2714 4.47746C15.1272 5.07585 14.1094 6.07803 13.7134 7.33125C13.3291 8.55041 13.4614 10.2483 15.4317 11.3857Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.234 13.9495C8.7794 15.698 7.08348 15.5423 5.948 14.9575C4.77943 14.3552 3.96309 13.1818 3.56708 11.9529C2.96091 10.0711 2.97551 8.31879 3.01734 7.94905C3.37249 7.84202 5.09274 7.50731 7.05332 7.75932C8.33377 7.92473 9.63661 8.51242 10.4413 9.5506C11.2245 10.5615 11.6877 12.2001 10.234 13.9495Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M16.5818 9.22052C16.5818 9.22052 12.108 13.0201 13.0888 20.7417"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
          <path
            d="M8.3916 12.4112C8.3916 12.4112 12.4684 14.0205 12.9267 18.0059"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="white"
          />
        </>
      )}
    </SvgIcon>
  );
};

export default LifestyleIcon;
